import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalDocsSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/patient/patient/get_external_docs_summary/`, {
    params: { patientId, trialId },
    headers: { Authorization: `Token ${token}` },
  });

  return res.data;
};

const useGetExternalDocsSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["external-docs-summary", patientId, trialId],
    queryFn: () => fetchExternalDocsSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetExternalDocsSummary;
